import { MktFooter } from '@playbooks/components/mkt/mkt-footer';
import { MktNav } from '@playbooks/components/mkt/mkt-nav';
import { Route } from '@playbooks/ui/components/route';
import { cn } from '@playbooks/ui/lib/utils';

const BlogWrapper = ({ seo = null, children, className = '' }) => {
	// Theme
	const rootClassName = cn('flex-column min-h-[100vh]', className);

	// Render
	return (
		<Route seo={seo} className={rootClassName}>
			<div className='fixed inset-x-0 top-0 z-10 pt-[env(safe-area-inset-top,0px)]'>
				<MktNav />
			</div>
			<main className='flex-column min-h-[100vh] w-full grow overflow-hidden pt-16 z-0'>{children}</main>
			<MktFooter />
		</Route>
	);
};
export { BlogWrapper };
